/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { POValidation, ValidatePONumber } from "@tKgpco/Services/ValidatePONumber";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = {
    poNumber: string;
} & HasOnSuccess<POValidation> &
    HasOnError;
type HandlerType = CustomApiHandler<Parameters, POValidation>;

export const BeginValidatePONumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/PoNumber",
        poNumber: props.parameter.poNumber,
    });
};

export const validatePO: HandlerType = async props => {
    try {
        props.apiResult = await ValidatePONumber(props.parameter.poNumber);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [BeginValidatePONumber, validatePO, ExecuteOnSuccess];

const validatePoNumber = createHandlerChainRunner(chain, "ValidatePoNumber");
export default validatePoNumber;
